import type { Environment } from './environment.model';

export const environment: Environment = {
  production: false,
  apiBase: 'https://api.soudanco.prg-dev.com/api/v1',
  fileBase: 'files',
  maxCacheSize: 1000,
  auth: {
    issuer: 'https://id.soudanco.prg-dev.com',
    clientId: '77700e04983903963189',
    showDebugInformation: true,
  },
};
